export default __webpack_public_path__ + "static/media/select-arrow.6cdac7fb.svg";